import { html, css, LitElement } from "lit-element";
import {localize} from "@stofloos/actions/localize";
import {LayoutFlex} from "@stofloos/globals/styles/layout-flex";
import "@stofloos/components/atoms/breadcrumb/sw-breadcrumb";
import get from "lodash-es/get";

// language=css
const swHeaderActionsStyle = css`
    h3 {
        margin-top: 0;
        margin-bottom: 0;
    }

    .bar-action {
		position: relative;
		background-color: var(--app-white, #fff);
		margin-left: auto;
        padding: 10px 30px;
        min-height: 60px;
        width: calc(100% - 60px);
		border-bottom: 1px solid var(--app-lightgrey);
	}

	.back {
        cursor: pointer;
        --sw-icon-width: auto;
        --sw-icon-height: 16px;
        height: 16px;
        padding: 32px 20px 32px 0;
		--sw-icon-color: var(--app-grey);
	}
`;

export class StofwareHeaderActions extends LitElement {
    static get properties() {
        return {
            title: String,
            endpoint: String,
            backButton: {type: Boolean},
            object: {type: Object},
            meta: {type: Object}
        };
    }
    static get styles() {
        return [LayoutFlex, swHeaderActionsStyle]
    }
    constructor() {
        super();
        this.meta = {};
    }

    render() {
        // language=HTML
        let title;
        if(this.meta.title_config)
            title = this.meta.title_config.map(obj => get(this.object, obj.name)).join(" ");
        else if(this.meta.model)
            title = this.meta.model.map(obj => get(this.object, obj.name)).join(" ");
        else
            title = "";

        return html`
            	<div class="bar-action layout horizontal">
                        ${this.backButton ? html`<a class="back" @click="${this.goBack}"><sw-icon icon="chevron-left"></sw-icon></a>` : ``}
                        <div class="layout vertical flex  center-center">
                            <sw-breadcrumb style="margin-right: auto;" title="${title}"></sw-breadcrumb>
                            <h3 style="margin-right: auto;">${localize(title)}</h3>
                        </div>
                        <slot></slot>
                </div>
		`;
    }

    goBack() {
        window.history.back();
    }
}

window.customElements.define("sw-header-actions", StofwareHeaderActions);
